export default __webpack_public_path__ + "static/media/trophy-fill.d30e6d31.svg";